import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { CasinoAdnLiveCasinoGame } from './game';

export const GamesList = ({
  gamesData, categoryId, loadGames, routePath,
}) => {
  const containerRef = useRef(null);

  const isLastPlayedPage = categoryId === 'lastPlayed';

  const lastPlayedGames = isLastPlayedPage && JSON.parse(sessionStorage.getItem('lastCasinoGames'));

  if (!gamesData && !isLastPlayedPage) return null;

  const gamesList = isLastPlayedPage ? lastPlayedGames : gamesData?.list;

  const onScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

    if (scrollTop + clientHeight >= scrollHeight - (scrollHeight / 2)) {
      loadGames({ isScroll: true });
    }
  };
  const isAllGamesLoaded = gamesList?.length >= gamesData?.total;

  return (
    <div
      ref={containerRef}
      className="casino-game-item"
      onScrollCapture={(!isLastPlayedPage && !isAllGamesLoaded) ? onScroll : null}
    >
      {gamesList?.map((item) => (
        <CasinoAdnLiveCasinoGame
          routePath={routePath}
          key={item.id}
          game={item}
        />
      ))}
    </div>
  );
};

GamesList.propTypes = {
  categoryId: PropTypes.number,
  gamesData: PropTypes.object,
  loadGames: PropTypes.func,
  routePath: PropTypes.string,
};
